import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { LossExcessListing } from './Pages'

export const lossExcessReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={LossExcessListing} />
    </Fragment>
)